// extracted by mini-css-extract-plugin
export default {"modal":"classes_modal__+ODtb","root":"classes_root__-x8wb","link":"classes_link__gKiZM","link-input":"classes_link-input__7XoOG","close":"classes_close__od8vA"};